import moment from "moment";

const formatTimeToDMMMYYYY = (date) => {
    return moment(date).isValid() && date ? moment(date).format("D MMM, YYYY") : '-';
}

export default formatTimeToDMMMYYYY;